module.exports = __webpack_public_path__ + "static/media/otherbank.a784d02c.png";